import { useRef, useState } from 'react';
import { Check } from 'lucide-react';
import { Section, SectionHeader, ProductFrame } from '../shared/blocks';
import { SHOWCASE } from './homeContent';

export function ProductShowcase() {
  const [active, setActive] = useState(0);
  const tabs = useRef([]);
  const item = SHOWCASE[active];

  const onKey = (e) => {
    const dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
    if (!dir) return;
    const next = (active + dir + SHOWCASE.length) % SHOWCASE.length;
    setActive(next);
    tabs.current[next]?.focus();
  };

  return (
    <Section id="product" data-testid="product-showcase">
      <SectionHeader eyebrow="The product" title="See what teachers actually do here." />
      <div role="tablist" aria-label="Product areas" className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1 mb-8" onKeyDown={onKey}>
        {SHOWCASE.map((s, i) => (
          <button
            key={s.id}
            ref={(el) => { tabs.current[i] = el; }}
            role="tab"
            id={`showcase-tab-${s.id}`}
            aria-selected={active === i}
            aria-controls="showcase-panel"
            tabIndex={active === i ? 0 : -1}
            onClick={() => setActive(i)}
            className={`shrink-0 px-5 h-11 rounded-full text-sm font-semibold border transition-colors ${active === i ? 'bg-mk-midnight text-white border-mk-midnight dark:bg-mk-blue dark:border-mk-blue' : 'bg-white text-mk-muted border-mk-line hover:text-mk-ink hover:border-mk-blue/50 dark:bg-transparent dark:border-mk-edge dark:text-slate-300'}`}
            data-testid={`showcase-tab-${s.id}`}
          >
            {s.tab}
          </button>
        ))}
      </div>
      <div id="showcase-panel" role="tabpanel" aria-labelledby={`showcase-tab-${item.id}`} className="grid lg:grid-cols-[1fr_2fr] gap-10 items-center">
        <div key={item.id} className="mk-rise">
          <h3 className="text-2xl sm:text-3xl font-bold tracking-tight text-mk-ink dark:text-white">{item.title}</h3>
          <ul className="mt-6 space-y-3">
            {item.points.map((p) => (
              <li key={p} className="flex items-start gap-3 text-mk-muted dark:text-slate-300">
                <span className="mt-0.5 h-5 w-5 rounded-full bg-mk-ice dark:bg-mk-navy grid place-items-center shrink-0"><Check className="h-3 w-3 text-mk-blue" aria-hidden="true" /></span>
                {p}
              </li>
            ))}
          </ul>
        </div>
        <ProductFrame key={item.img} src={item.img} alt={item.alt} label={item.tab} testid="showcase-active-screenshot" className="mk-rise" />
      </div>
    </Section>
  );
}
